import {FC, ReactNode} from 'react'

export const FormError: FC<{children: ReactNode}> = ({children}) => {
  return <div className='mt-2 font-medium text-danger text-fs-10'>{children}</div>
}
